export const isEstateApproved = (estateApproved?: boolean, ownerApproved?: boolean) => {
  if (estateApproved === true || ownerApproved === true) return true
  return false
}

export const getApprovalStatusLabel = (
  estateApproved?: boolean,
  ownerApproved?: boolean
) => {
  return isEstateApproved(estateApproved, ownerApproved) ? 'Approved' : 'Pending'
}
